import { createApp } from 'vue';
import App from './chat/App.vue';

const app = createApp(App);
app.mount('#chat');
